const HRAppraisalPrinc = () => {
	return `mutation hrAppraisal(
		$appraisee_id: String
		$principles: [AppraisalInput]
	) {
		hrAppraisal(
			appraisee_id: $appraisee_id
			principles: $principles
		)
	}`;
}

export default HRAppraisalPrinc;
